export const transformFilterToId = (value: string): string => {
  switch (value) {
    case "filter_hardware_type":
      return "hardware";
    case "filter_sim_type":
      return "simType";
    case "filter_sim_gprs_last_conn_start":
      return "simGPRSLastConnectionStart";
    case "filter_sim_gprs_last_conn_stop":
      return "simGPRSLastConnectionStop";
    case "filter_sim_msisdn":
      return "simMsisdn";
    case "filter_sim_life_cycle_status":
      return "simLifeCycleStatus"
    case "filter_sim_commercial_group":
      return "simCommercialGroup"
    case "filter_sim_consumption_monthly_data":
      return "simConsumptionMonthlyData"
    case "filter_firmware_version":
      return "firmwareVersion";
    case "filter_model":
      return "vehicleModel";
    case "filter_brand":
      return "vehicleBrand";
    case "filter_type_name":
      return "vehicleType";
    case "filter_configuration_name":
      return "configName";
    case "filter_vehicle_groups":
      return "groups";
    case "filter_template_name":
      return "vehicleTemplate";
    case "filter_fsm_state_name":
      return "stateMachineState";
    case "filter_fw_upload_status":
      return "firmwareUploadStatus";
    case "filter_config_upload_status":
      return "configUploadStatus";
    case "filter_vin":
      return "vin";
    case "filter_is_lsva":
      return "isLSVA";
    case "filter_billing_tarif_licence":
      return "billingTariff";
    default:
      return value.replace("filter_", "");
  }
};

export const transformIdToFilter = (value: string): string => {
  switch (value) {
    case "hardware":
      return "filter_hardware_type";
    case "simType":
      return "filter_sim_type";
    case "simGPRSLastConnectionStart":
      return "filter_sim_gprs_last_conn_start";
    case "simGPRSLastConnectionStop":
      return "filter_sim_gprs_last_conn_stop";
    case "simMsisdn":
      return "filter_sim_msisdn";
    case "simLifeCycleStatus":
      return "filter_sim_life_cycle_status";
    case "simCommercialGroup":
      return "filter_sim_commercial_group";
    case "simConsumptionMonthlyData":
      return "filter_sim_consumption_monthly_data";
    case "firmwareVersion":
      return "filter_firmware_version";
    case "vehicleModel":
      return "filter_model";
    case "vehicleBrand":
      return "filter_brand";
    case "vehicleType":
      return "filter_type_name";
    case "configName":
      return "filter_configuration_name";
    case "groups":
      return "filter_vehicle_groups";
    case "vehicleTemplate":
      return "filter_template_name";
    case "stateMachineState":
      return "filter_fsm_state_name";
    case "configState":
      return "filter_fsm_state_name";
    case "firmwareUploadStatus":
      return "filter_fw_upload_status";
    case "isLSVA":
      return "filter_is_lsva";
    case "vin":
      return "filter_vin";
    case "configUploadStatus":
      return "filter_config_upload_status";
    case "billingTariff":
      return "filter_billing_tarif_licence";
    default:
      return `filter_${value}`;
  }
};

export const transformIdToSort = (value: string, desc: boolean): string => {
  const order = desc ? "DESC" : "ASC";
  switch (value) {
    case "hardware":
      return `hardware_type ${order}`;
    case "firmwareVersion":
      return `firmware_version ${order}`;
    case "vehicleModel":
      return `model ${order}`;
    case "vehicleBrand":
      return `brand ${order}`;
    case "simType":
      return `sim_type ${order}`;
    case "simGPRSLastConnectionStart":
      return `sim_gprs_last_conn_start ${order}`;
    case "simGPRSLastConnectionStop":
      return `sim_gprs_last_conn_stop ${order}`;
    case "simMsisdn":
      return `sim_msisdn ${order}`;
    case "simLifeCycleStatus":
      return `sim_life_cycle_status ${order}`;
    case "simCommercialGroup":
      return `sim_commercial_group ${order}`;
    case "simConsumptionMonthlyData":
      return `sim_consumption_monthly_data ${order}`;
    case "vehicleType":
      return `type_name ${order}`;
    case "configName":
      return `configuration_name ${order}`;
    case "vehicleTemplate":
      return `template_name ${order}`;
    case "smsResponse":
      return `sms_response ${order}`;
    case "smsResponseDatetime":
      return `sms_response_datetime ${order}`;
    case "currentDataDatetime":
      return `datetime ${order}`;
    case "stateMachineState":
      return `fsm_state_name ${order}`;
    case "configState":
      return `fsm_state_name ${order}`;
    case "firmwareUploadStatus":
      return `fw_upload_status ${order}`;
    case "isLSVA":
      return `is_lsva ${order}`;
    case "vin":
      return `vin ${order}`;
    case "configUploadStatus":
      return `config_upload_status ${order}`;
    case "billingTariff":
      return `billing_tarif_licence ${order}`;
    default:
      return `${value} ${order}`;
  }
};

export const mapDeviceResponse = (x: any) => ({
  imei: x.imei,
  customer: x.customer,
  vehicle_uuid: x.vehicle_uuid,
  template: x.template || "",
  name: x.vehicle?.data?.name || "",
  vin: x.vehicle?.data?.vin || "",
  isLSVA: x.vehicle?.data?.lsva?.is_lsva || false,
  hardware: x.hardware_type || "",
  simType: x.sim_type || "",
  simGPRSLastConnectionStart: x.sim_gprs_last_conn_start || "",
  simGPRSLastConnectionStop: x.sim_gprs_last_conn_stop || "",
  simMsisdn: x.sim_msisdn || "",
  simLifeCycleStatus: x.sim_life_cycle_status || "",
  simCommercialGroup: x.sim_commercial_group || "",
  simConsumptionMonthlyData: x.sim_consumption_monthly_data || "",
  configName: x.configuration_name || "",
  configDateTime: x.status?.config_upload_status?.datetime,
  configUploadStatus: x.status?.config_upload_status?.status,
  smsResponse: x.state_machine?.data?.tco_set_sms_command_data?.response || "",
  smsResponseDatetime: x.state_machine?.data?.tco_set_sms_command_data?.datetime || "",
  firmwareUploadStatus: x.status?.firmware_upload_status?.status || "",
  firmwareDateTime: x.status?.firmware_upload_status?.datetime || "",
  groups: x.vehicle?.data?.vehicle_groups?.map((g) => g.name).join(", ") || "",
  vehicleTemplate: x.vehicle?.data?.template_name || "",
  vehicleModel: x.vehicle?.data?.vehicle_model?.model || "",
  vehicleBrand: x.vehicle?.data?.vehicle_model?.brand || "",
  vehicleType: x.vehicle?.data?.vehicle_model?.vehicle_type?.name || "",
  firmwareVersion: x.firmware_version || "",
  configState: x.status?.config_state || "",
  stateMachineState: x.state_machine?.state_name || "",
  currentDataDatetime: x.current_status_with_changes?.datetime || "",
  currentData: JSON.stringify(x.current_status_with_changes || {}),
  tacho: x.variables?.$tacho || x.vehicle?.data?.vehicle_service?.tacho || "",
  billingTariff:
    x.vehicle?.data?.vehicle_internals?.billing_tarif_licence == null
      ? ""
      : Number(x.vehicle?.data?.vehicle_internals?.billing_tarif_licence),
});